@if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<ag-grid-angular
  style="height: 100%; height: calc(100% - var(--mat-toolbar-standard-height)); width: 100%;"
  class="ag-theme-balham"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  [defaultColDef]="defaultColDef"
  (rowClicked)="onRowClicked($event)">
</ag-grid-angular>
